import { MutationResult } from "@/api/utils/types"
import { IAddNote } from "./NoteMutator.types"
import { useMutation } from "@/api/utils/useQuery"
import {
  BackofficeRestMutations,
  CreateAccountNotePayload,
} from "@/api/backofficeRest/mutations"
import { useCurrentAccountStore } from "@/stores/currentAccount"
import Cache from "@/api/utils/Cache"

export interface INoteMutator {
  addNote(invalidateCache: boolean): MutationResult<IAddNote, void>
}

class NoteMutatorClass implements INoteMutator {
  addNote(invalidateCache = true): MutationResult<IAddNote, void> {
    return useMutation({
      ...BackofficeRestMutations.account.createNote(),
      serializerFn: (data: IAddNote): CreateAccountNotePayload => {
        const billingAccountId = useCurrentAccountStore().coreId.data
        if (!billingAccountId) throw new Error("Missing coreId")
        return {
          billingAccountId,
          body: {
            subject: data.subject,
            content: data.content,
            summary: data.summary,
          },
        }
      },
      // onSuccessFn replaces useMutation's own invalidation branch, so the
      // caller's invalidateCache flag has to be honoured here.
      onSuccessFn: () => {
        invalidateCache && Cache.clear()
      },
    })
  }
}

export const NoteMutator = new NoteMutatorClass()
